export default {
	name: 'Convention.Schedule.Personal.Hosting',
	path: 'convention/schedule/personal/hosting',
	topLevel: true,
	parent: 'Convention.Schedule.Personal',
	collection: {
		component: 'ConventionSchedulePersonal',
		params: {
			hosting: true
		}
	},
	meta: {
		auth: true
	}
}